import { Mesh, MeshBasicMaterial, RingGeometry } from "three";
export class Donut extends Mesh {
    constructor(color, opacity = 0.8, radius = 1, thickness = 0.2, z = 0, skipHistory = false) {
        const geometry = radius === 1 && thickness === 0.2 ? Donut.defaultGeometry : new RingGeometry(radius, radius + thickness, 32, 1);
        super(geometry, new MeshBasicMaterial({ color: color, transparent: true, opacity: opacity }));
        this.name = "Donut";
        this.interceptedByRaycaster = false;
        this.position.z = z;
        this.__skipHistory = skipHistory;
    }
    dispose() {
        super.dispose();
        this.material.dispose();
        this.geometry !== Donut.defaultGeometry && this.geometry.dispose();
    }
}
Donut.defaultGeometry = new RingGeometry(1, 1.2, 32, 1);
//# sourceMappingURL=Donut.js.map